export default {"src":"/_next/static/media/file-analysis.46031243.svg","height":634,"width":782};